export function Page({
  title,
  actions,
  children,
}: {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="px-3 py-4 sm:px-6 sm:py-5 max-w-screen-2xl mx-auto">
      <header className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between mb-4">
        <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
        <div className="flex items-center gap-2 flex-wrap">{actions}</div>
      </header>
      <div className="space-y-4">{children}</div>
    </div>
  );
}
